import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';

/** Resultado de consultar/marcar novedades vistas. */
export class WhatsNewSeenDto {
    seen: boolean;
}

/**
 * What's New - novedades por tanda (whatsNewId estable, no la versión del build; el pipeline
 * reescribe la versión del front en cada compilación). El "visto" se persiste por usuario en BD
 * (auditoría de adopción) y se cachea en localStorage para no consultar en cada navegación.
 */
@Injectable()
export class WhatsNewFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    /** ¿El usuario ya vio las novedades de esta tanda? */
    GetStatus(whatsNewId: string): Observable<RequestResponse<WhatsNewSeenDto>> {
        return this._httpClient.get<RequestResponse<WhatsNewSeenDto>>(
            this._urlBase + 'api/WhatsNew/Status?whatsNewId=' + encodeURIComponent(whatsNewId));
    }

    /** Marca la tanda como vista (idempotente). */
    MarkSeen(whatsNewId: string): Observable<RequestResponse<WhatsNewSeenDto>> {
        return this._httpClient.post<RequestResponse<WhatsNewSeenDto>>(
            this._urlBase + 'api/WhatsNew/MarkSeen?whatsNewId=' + encodeURIComponent(whatsNewId), {});
    }
}
